var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#FF4453",
    mask: "url(#mask-2)",
    x: 13.3333333,
    y: 0,
    width: 14.6666667,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#FFCF3C",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 0,
    width: 9.33333333,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/BE.036a8bcbdd43ca8c41ddcb786b5c76a5.svg";
export { ForwardRef as ReactComponent };